/**
 * Corporate/reseller checkbox mutual exclusion + the corporate company-name field's
 * show/hide, replacing form.vue's :disabled="reseller_checkbox"/":disabled="corporate_request"
 * bindings and its `corporate_request ? 'display' : ''` class binding.
 */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['corporateCheckbox', 'companyField', 'companyInput', 'resellerCheckbox']

  connect() {
    this.toggle()
  }

  toggle() {
    const corporate = this.corporateCheckboxTarget.checked
    const reseller = this.resellerCheckboxTarget.checked
    this.corporateCheckboxTarget.disabled = reseller
    this.resellerCheckboxTarget.disabled = corporate
    this.companyFieldTarget.style.display = corporate ? '' : 'none'
    this.companyInputTarget.disabled = !corporate
  }
}
